// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   PREMIUM SERVICES SECTION - TIMELINE STYLE
================================ */

.services-section {
    padding: 120px 0;
    position: relative;
    overflow: hidden;
}

/* ================================
   SECTION HEADER
================================ */

.section-header {
    text-align: center;
    margin-bottom: 100px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.section-subtitle {
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
}

/* ================================
   TIMELINE CONNECTOR
================================ */

.services-grid {
    position: relative;
    max-width: 1000px;
    margin: 0 auto;
}

.services-grid::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, 
        transparent,
        rgba(99, 102, 241, 0.4) 10%,
        rgba(168, 85, 247, 0.4) 90%,
        transparent
    );
    transform: translateX(-50%);
    z-index: 0;
}

/* ================================
   SERVICE ITEM - ALTERNATING
================================ */

.service-card {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 80px;
    opacity: 0;
    animation: slideIn 0.8s ease-out both;
}

.service-card[data-index="0"] { animation-delay: 0.1s; }
.service-card[data-index="1"] { animation-delay: 0.2s; }
.service-card[data-index="2"] { animation-delay: 0.3s; }
.service-card[data-index="3"] { animation-delay: 0.4s; }
.service-card[data-index="4"] { animation-delay: 0.5s; }
.service-card[data-index="5"] { animation-delay: 0.6s; }

/* Alternate left/right */
.service-card[data-index="0"],
.service-card[data-index="2"],
.service-card[data-index="4"] {
    flex-direction: row;
}

.service-card[data-index="1"],
.service-card[data-index="3"],
.service-card[data-index="5"] {
    flex-direction: row-reverse;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(40px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ================================
   CARD CONTENT CONTAINER
================================ */

.card-content-wrapper {
    flex: 1 1;
    padding: 0 40px;
    position: relative;
}

.service-card[data-index="1"] .card-content-wrapper,
.service-card[data-index="3"] .card-content-wrapper,
.service-card[data-index="5"] .card-content-wrapper {
    text-align: right;
}

/* ================================
   NUMBER CIRCLE (Timeline Node)
================================ */

.card-number-circle {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    border-radius: 50%;
    font-size: 1.75rem;
    font-weight: 700;
    color: #ffffff;
    box-shadow: 
        0 8px 30px rgba(99, 102, 241, 0.5),
        0 0 0 4px rgba(99, 102, 241, 0.2);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 2;
}

.service-card:hover .card-number-circle {
    transform: scale(1.15) rotate(10deg);
    box-shadow: 
        0 12px 40px rgba(168, 85, 247, 0.6),
        0 0 0 6px rgba(168, 85, 247, 0.3);
}

/* ================================
   ICON
================================ */

.card-icon {
    font-size: 3.5rem;
    margin-bottom: 16px;
    display: inline-block;
    filter: drop-shadow(0 4px 15px rgba(168, 85, 247, 0.5));
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.service-card:hover .card-icon {
    transform: translateY(-6px) scale(1.15) rotate(-5deg);
    filter: drop-shadow(0 8px 25px rgba(236, 72, 153, 0.6));
}

/* ================================
   TEXT CONTENT
================================ */

.card-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    line-height: 1.3;
    transition: all 0.3s ease;
}

.service-card:hover .card-title {
    background: linear-gradient(135deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.card-description {
    font-size: 1.0625rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
    margin: 0;
}

/* ================================
   CONNECTING LINES
================================ */

.service-card::after {
    content: '';
    position: absolute;
    width: 100px;
    height: 2px;
    background: linear-gradient(90deg, 
        rgba(99, 102, 241, 0.6),
        rgba(168, 85, 247, 0.3)
    );
    top: 40px;
    opacity: 0;
    transition: all 0.4s ease;
}

.service-card[data-index="0"]::after,
.service-card[data-index="2"]::after,
.service-card[data-index="4"]::after {
    left: calc(50% + 40px);
}

.service-card[data-index="1"]::after,
.service-card[data-index="3"]::after,
.service-card[data-index="5"]::after {
    right: calc(50% + 40px);
}

.service-card:hover::after {
    opacity: 1;
}

/* ================================
   RESPONSIVE
================================ */

@media (max-width: 992px) {
    .services-grid::before {
        left: 40px;
    }

    .service-card {
        flex-direction: row !important;
        text-align: left !important;
    }

    .service-card[data-index="1"] .card-content-wrapper,
    .service-card[data-index="3"] .card-content-wrapper,
    .service-card[data-index="5"] .card-content-wrapper {
        text-align: left;
    }

    .card-content-wrapper {
        padding: 0 0 0 30px;
    }

    .service-card::after {
        display: none;
    }
}

@media (max-width: 768px) {
    .services-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 70px;
    }

    .services-grid::before {
        left: 30px;
    }

    .service-card {
        margin-bottom: 60px;
    }

    .card-number-circle {
        width: 60px;
        height: 60px;
        font-size: 1.25rem;
    }

    .card-icon {
        font-size: 2.75rem;
    }

    .card-title {
        font-size: 1.375rem;
    }

    .card-description {
        font-size: 0.9375rem;
    }

    .card-content-wrapper {
        padding: 0 0 0 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;kCAEkC;;AAElC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;;kCAEkC;;AAElC;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV;;;;;KAKC;IACD,2BAA2B;IAC3B,UAAU;AACd;;AAEA;;kCAEkC;;AAElC;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,qCAAqC;AACzC;;AAEA,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;;AAEvD,yBAAyB;AACzB;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;kCAEkC;;AAElC;IACI,SAAO;IACP,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;kCAEkC;;AAElC;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qDAAqD;IACrD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;;yCAEqC;IACrC,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC;;yCAEqC;AACzC;;AAEA;;kCAEkC;;AAElC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;IACvD,kDAAkD;AACtD;;AAEA;IACI,qDAAqD;IACrD,uDAAuD;AAC3D;;AAEA;;kCAEkC;;AAElC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;AACb;;AAEA;;kCAEkC;;AAElC;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX;;;KAGC;IACD,SAAS;IACT,UAAU;IACV,yBAAyB;AAC7B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;;kCAEkC;;AAElC;IACI;QACI,UAAU;IACd;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* ================================\n   PREMIUM SERVICES SECTION - TIMELINE STYLE\n================================ */\n\n.services-section {\n    padding: 120px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ================================\n   SECTION HEADER\n================================ */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 100px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.section-subtitle {\n    font-size: 1.125rem;\n    color: rgba(255, 255, 255, 0.75);\n    font-weight: 500;\n}\n\n/* ================================\n   TIMELINE CONNECTOR\n================================ */\n\n.services-grid {\n    position: relative;\n    max-width: 1000px;\n    margin: 0 auto;\n}\n\n.services-grid::before {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    background: linear-gradient(to bottom, \n        transparent,\n        rgba(99, 102, 241, 0.4) 10%,\n        rgba(168, 85, 247, 0.4) 90%,\n        transparent\n    );\n    transform: translateX(-50%);\n    z-index: 0;\n}\n\n/* ================================\n   SERVICE ITEM - ALTERNATING\n================================ */\n\n.service-card {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 80px;\n    opacity: 0;\n    animation: slideIn 0.8s ease-out both;\n}\n\n.service-card[data-index=\"0\"] { animation-delay: 0.1s; }\n.service-card[data-index=\"1\"] { animation-delay: 0.2s; }\n.service-card[data-index=\"2\"] { animation-delay: 0.3s; }\n.service-card[data-index=\"3\"] { animation-delay: 0.4s; }\n.service-card[data-index=\"4\"] { animation-delay: 0.5s; }\n.service-card[data-index=\"5\"] { animation-delay: 0.6s; }\n\n/* Alternate left/right */\n.service-card[data-index=\"0\"],\n.service-card[data-index=\"2\"],\n.service-card[data-index=\"4\"] {\n    flex-direction: row;\n}\n\n.service-card[data-index=\"1\"],\n.service-card[data-index=\"3\"],\n.service-card[data-index=\"5\"] {\n    flex-direction: row-reverse;\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(40px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ================================\n   CARD CONTENT CONTAINER\n================================ */\n\n.card-content-wrapper {\n    flex: 1;\n    padding: 0 40px;\n    position: relative;\n}\n\n.service-card[data-index=\"1\"] .card-content-wrapper,\n.service-card[data-index=\"3\"] .card-content-wrapper,\n.service-card[data-index=\"5\"] .card-content-wrapper {\n    text-align: right;\n}\n\n/* ================================\n   NUMBER CIRCLE (Timeline Node)\n================================ */\n\n.card-number-circle {\n    width: 80px;\n    height: 80px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    border-radius: 50%;\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #ffffff;\n    box-shadow: \n        0 8px 30px rgba(99, 102, 241, 0.5),\n        0 0 0 4px rgba(99, 102, 241, 0.2);\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    z-index: 2;\n}\n\n.service-card:hover .card-number-circle {\n    transform: scale(1.15) rotate(10deg);\n    box-shadow: \n        0 12px 40px rgba(168, 85, 247, 0.6),\n        0 0 0 6px rgba(168, 85, 247, 0.3);\n}\n\n/* ================================\n   ICON\n================================ */\n\n.card-icon {\n    font-size: 3.5rem;\n    margin-bottom: 16px;\n    display: inline-block;\n    filter: drop-shadow(0 4px 15px rgba(168, 85, 247, 0.5));\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.service-card:hover .card-icon {\n    transform: translateY(-6px) scale(1.15) rotate(-5deg);\n    filter: drop-shadow(0 8px 25px rgba(236, 72, 153, 0.6));\n}\n\n/* ================================\n   TEXT CONTENT\n================================ */\n\n.card-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    line-height: 1.3;\n    transition: all 0.3s ease;\n}\n\n.service-card:hover .card-title {\n    background: linear-gradient(135deg, #818cf8, #c084fc);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.card-description {\n    font-size: 1.0625rem;\n    color: rgba(255, 255, 255, 0.8);\n    line-height: 1.8;\n    margin: 0;\n}\n\n/* ================================\n   CONNECTING LINES\n================================ */\n\n.service-card::after {\n    content: '';\n    position: absolute;\n    width: 100px;\n    height: 2px;\n    background: linear-gradient(90deg, \n        rgba(99, 102, 241, 0.6),\n        rgba(168, 85, 247, 0.3)\n    );\n    top: 40px;\n    opacity: 0;\n    transition: all 0.4s ease;\n}\n\n.service-card[data-index=\"0\"]::after,\n.service-card[data-index=\"2\"]::after,\n.service-card[data-index=\"4\"]::after {\n    left: calc(50% + 40px);\n}\n\n.service-card[data-index=\"1\"]::after,\n.service-card[data-index=\"3\"]::after,\n.service-card[data-index=\"5\"]::after {\n    right: calc(50% + 40px);\n}\n\n.service-card:hover::after {\n    opacity: 1;\n}\n\n/* ================================\n   RESPONSIVE\n================================ */\n\n@media (max-width: 992px) {\n    .services-grid::before {\n        left: 40px;\n    }\n\n    .service-card {\n        flex-direction: row !important;\n        text-align: left !important;\n    }\n\n    .service-card[data-index=\"1\"] .card-content-wrapper,\n    .service-card[data-index=\"3\"] .card-content-wrapper,\n    .service-card[data-index=\"5\"] .card-content-wrapper {\n        text-align: left;\n    }\n\n    .card-content-wrapper {\n        padding: 0 0 0 30px;\n    }\n\n    .service-card::after {\n        display: none;\n    }\n}\n\n@media (max-width: 768px) {\n    .services-section {\n        padding: 80px 0;\n    }\n\n    .section-header {\n        margin-bottom: 70px;\n    }\n\n    .services-grid::before {\n        left: 30px;\n    }\n\n    .service-card {\n        margin-bottom: 60px;\n    }\n\n    .card-number-circle {\n        width: 60px;\n        height: 60px;\n        font-size: 1.25rem;\n    }\n\n    .card-icon {\n        font-size: 2.75rem;\n    }\n\n    .card-title {\n        font-size: 1.375rem;\n    }\n\n    .card-description {\n        font-size: 0.9375rem;\n    }\n\n    .card-content-wrapper {\n        padding: 0 0 0 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
